import { useMemo } from 'react';

import type { TRAFFIC_SHARE_TAB_KEY, TRAFFIC_VISITS_TAB_KEY } from '../domain/user';
import { useUserSettings } from '../features/user/useUserSettings';
import type { TrafficShareTab } from '../pages/company-overview/TrafficShare/TrafficShare';
import type { TrafficVisitsTab } from '../pages/company-overview/TrafficVisits/TrafficVisits';

export const useStoredTabState = <T extends TrafficShareTab | TrafficVisitsTab>({
  storageKey,
  defaultTab,
  tabs,
}: {
  storageKey: typeof TRAFFIC_SHARE_TAB_KEY | typeof TRAFFIC_VISITS_TAB_KEY;
  defaultTab: T;
  tabs: T[];
}) => {
  const { getUserSetting, setUserSettings } = useUserSettings();
  const visitsTabFromSettings = getUserSetting(storageKey);

  const activeTab = useMemo(() => {
    return !!visitsTabFromSettings && tabs.includes(visitsTabFromSettings as T) ? visitsTabFromSettings : defaultTab;
  }, [visitsTabFromSettings]) as T;

  const onSelectTab = (tabName: T) => {
    if (tabName !== activeTab) {
      setUserSettings({ [storageKey]: tabName });
    }
  };

  return { activeTab, onSelectTab };
};
